export enum Permissions {
  //Auth_Permissions
  LOGIN = "login",
  LOGOUT = "logout",
  GET_ROLE = "getRole",
  DELETE_ROLE = "deleteRole",
  GET_ROLES = "getAllRoles",
  CREATE_ROLE = "createRole",
  CREATE_ROLE_PERMISSION = "createRolePermission",
  VALIDATE_CREDENTIALS = "validateCredentials",
  GET_USER_BRANCHES = "getUserBranches",
  CHECK_TOKEN = "checkToken",
  ADD_MISSING_ROLE_PERMISSIONS = "addMissingRolePermissions",
  CREATE_NEW_ADMIN_ROLE_TO_TENANT = "createNewAdminRoleToTenant",
  ADD_MISSING_DEFAULT_ADMIN_ROLE_PERMISSIONS = "addMissingDefaultAdminRolePermissions",
  CREATE_NEW_OWNER_ROLE_TO_TENANT = "createNewOwnerRoleToTenant",
  ADD_MISSING_DEFAULT_OWNER_ROLE_PERMISSIONS = "addMissingDefaultOwnerRolePermissions",

  //Clinic_Management_Permissions
  ADD_EMPLOYEE_USER = "addEmployeeAndUser",
  EDIT_EMPLOYEE_USER = "editTenantEmployeeAndUser",
  ADD_EMPLOYEE_TENANT = "addEmployeetoTenant",
  GET_EMPLOYEES_TENANT = "getEmployeesofTenant",
  EDIT_TENANT_EMPLOYEE = "editTenantEmployee",
  DELETE_TENANT_EMPLOYEE = "deleteTenantEmployee",
  GET_TENANT_EMPLOYEE_BY_ID = "getTenantEmployeeById",
  APPROVE_EMPLOYEE_TENANT = "approveEmployeetoTenant",
  GET_EMPLOYEE_SIGNUPS = "getEmployeeSignups",
  SIGN_UP_EMPLOYEE_TENANT = "signUpEmployeetoTenant",
  ADD_BRANCH_TENANT = "addBranchToTenant",
  GET_BRANCHES_TENANT = "getBranchsofTenant",
  EDIT_TENANT_BRANCH = "editTenantBranch",
  DELETE_TENANT_BRANCH = "deleteTenantBranch",
  GET_TENANT_BRANCH_BY_ID = "getTenantBranchById",
  REMOVE_EMPLOYEE_FROM_BRANCH = "removeEmployeeFromBranch",
  GIVE_BRANCH_ACCESS = "employeeBranchAccess",

  //  Medical_Operations_Permissions
  GET_PATIENTS_OF_TENANT = "getPatientsofTenant",
  GET_TENANT_PATIENT_BY_ID = "getTenantPatientById",
  EDIT_TENANT_PATIENT = "editTenantPatient",
  ADD_PATIENT_USER = "addPatientAndUser",
  ADD_PATIENT_TO_TENANT = "addPatienttoTenant",
  DELETE_TENANT_PATIENT = "deleteTenantPatient",
  SCHEDULE_APPOINTMENT = "scheduleAppointment",
  GET_APPOINTMENTS = "getAppointments",
  EDIT_APPOINTMENT = "editAppointment",
  DELETE_APPOINTMENT = "deleteAppointment",
  GET_APPOINTMENT_BY_ID = "getAppointmentById",
  GET_APPOINTMENT_TREE_BY_ID = "getAppointmentTreeById",
  ADD_DIAGNOSIS = "addDiagnosis",
  GET_DIAGNOSES = "getDiagnoses",
  EDIT_DIAGNOSIS = "editDiagnosis",
  DELETE_DIAGNOSIS = "deleteDiagnosis",
  GET_DIAGNOSIS_BY_ID = "getDiagnosisById",
  ADD_PATIENT_DIAGNOSIS = "addPatientDiagnosis",
  GET_PATIENT_DIAGNOSES = "getPatientDiagnoses",
  EDIT_PATIENT_DIAGNOSIS = "editPatientDiagnosis",
  DELETE_PATIENT_DIAGNOSIS = "deletePatientDiagnosis",
  GET_PATIENT_DIAGNOSIS_BY_ID = "getPatientDiagnosisById",
  EDIT_APPOINTMENT_OBSERVATION = "editAppointmentObservation",
  DELETE_APPOINTMENT_OBSERVATION = "deleteAppointmentObservation",
  ADD_APPOINTMENT_OBSERVATION = "addAppointmentObservation",
  EDIT_PATIENT_OBSERVATION = "editPatientObservation",
  DELETE_PATIENT_OBSERVATION = "deletePatientObservation",
  ADD_PATIENT_OBSERVATION = "addPatientObservation",
  ADD_MEDICATION = "addMedication",
  GET_MEDICATION = "getMedication",
  GET_MEDICATION_BY_ID = "getMedicationById",
  EDIT_MEDICATION = "editMedication",
  DELETE_MEDICATION = "deleteMedication",
  ADD_TESTS = "addTests",
  GET_TESTS = "getTests",
  GET_TESTS_BY_ID = "getTestsById",
  EDIT_TESTS = "editTests",
  DELETE_TESTS = "deleteTests",
  ADD_EQUIPEMNT = "addEquipment",
  GET_EQUIPEMNT = "getEquipment",
  GET_EQUIPEMNT_BY_ID = "getEquipmentById",
  EDIT_EQUIPEMNT = "editEquipment",
  DELETE_EQUIPEMNT = "deleteEquipment",
  GET_MEDICATION_BY_CODE = "getMedicationByCode",
  GET_EQUIPMENT_BY_CODE = "getEquipmentByCode",
  GET_TEST_BY_CODE = "getTestByCode",
  ADD_DEFAULT_SETS = "addDefaultSets",
  GET_DEFAULT_SETS = "getDefaultSets",
  GET_DEFAULT_SETS_BY_CODE = "getDefaultSetsByCode",
  EDIT_DEFAULT_SETS = "editDefaultSets",
  DELETE_DEFAULT_SETS = "deleteDefaultSets",
  GET_DEFAULT_SETS_BY_ID = "getDefaultSetsById",
  GET_FILTERED_CALENDAR = "getFilteredCalendar",
  EDIT_PATIENT_TREATMENT = "editPatientTreatment",
  CREATE_PATIENT_TREATMENT = "createPatientTreatment",
  GET_PATIENT_TREATMENT_BY_ID = "getPatientTreatmentById",
  DELETE_PATIENT_TREATMENT_BY_ID = "deletePatientTreatmentById",
  GET_ALL_PATIENT_TREATMENTS_OF_DIAGNOSIS = "getAllPatientTreatmentsOfDiagnosis",
  ADD_PATIENT_TESTS = "addPatientTests",
  GET_PATIENT_TESTS = "getPatientTests",
  EDIT_PATIENT_TESTS = "editPatientTests",
  DELETE_PATIENT_TESTS = "deletePatientTests",
  GET_PATIENT_TESTS_BY_ID = "getPatientTestsById",
  EDIT_TENANT_PATIENT_USER = "editTenantPatientAndUser",
  ADD_PATIENT_ARCHIVE = "addPatientArchive",
  GET_ARCHIVES = "getArchives",
  EDIT_ARCHIVES = "editArchives",
  DELETE_ARCHIVES = "deleteArchives",
  GET_ARCHIVE_BY_ID = "getArchivesById",
  GET_GROUPS = "getGroups",
  EDIT_GROUPS = "editGroup",
  ADD_GROUPS = "addGroup",
  DELETE_GROUPS = "deleteGroup",
  ADD_PATIENT_TO_GROUPS = "addPatientToGroups",
  GET_GROUP_MEMBERS = "getMembersOfGroup",
  DELETE_PATIENT_FROM_GROUP = "deletePatientFromGroup",

  CREATE_TEMPLATE = "createNewTemplate",
  EDIT_TEMPLATE = "editTemplate",
  DELETE_TEMPLATE = "deleteTemplate",
  CREATE_INVENTORY = "createNewInventory",
  EDIT_COLLECTIONS = "editCollection",
  ADD_COLLECTIONS = "addNewCollection",
  DELETE_COLLECTIONS = "deleteCollection",
  ADD_FIELDS = "addNewField",
  DELETE_FIELD = "deleteField",
  
  EDIT_INVENTORY = "editInventory",
  DEACTIVATE_INVENTORY = "toggleInventoryStatus",
  ACTIVATE_INVENTORY = "toggleInventoryStatus",
  EDIT_ITEM = "editInventoryItem",
  ADD_ITEM = "addNewItem",
  DELETE_ITEM = "deleteInventoryItem",

  // File_Mangement_Permissions
  UPLOAD_FILE = "uploadFile",
  GET_FILE = "getFile",
  DELETE_FILE = "deleteFile",
  MOVE_FROM_TEMP_TO_PERMANENT = "moveFromTempToPermanent",
  DELETE_OLD_TEMP_FILES = "deleteOldTempFiles",
  DOWNLOAD_FILE = "downloadFile",
  MOVE_MULTIPLE_TEMP_FILES_TO_PERMANENT = "moveMultipleTempFilesToPermanent",

  // User_Mangement_Permissions
  // LOGIN = "login",
  ADD_USER = "addUser",
  GET_USERS = "getUsers",
  EDIT_USER = "editUser",
  DELETE_USER = "deleteUser",
  GET_USER_BY_ID = "getUserById",
  GET_USER_PROFILE_BY_ID = "getUserProfileById",
  UPLOAD_PHOTO = "uploadPhoto",
  ADD_TENANT = "addTenant",
  GET_TENANT = "getTenants",
  EDIT_TENANT = "editTenant",
  DELETE_TENANT = "deleteTenant",
  GET_TENANT_BY_ID = "getTenantById",
  UPLOAD_TENANT_PHOTO = "uploadTenantPhoto",

  // Payment Permissions
  ADD_CURRENCY = "createCurrency",
  GET_CURRENCY = "getCurrency",
  EDIT_CURRENCY = "editCurrency",
  DELETE_CURRENCY = "deleteCurrency",

  ADD_PATIENT_RECEIPT = "createReceipt",
  GET_PATIENT_RECEIPT = "getReceipt",
  EDIT_PATIENT_RECEIPT = "editReceipt",
  DELETE_PATIENT_RECEIPT = "deleteReceipt",

  ADD_PATIENT_BILL = "createBill",
  GET_PATIENT_BILL = "getBill",
  EDIT_PATIENT_BILL = "editBill",
  DELETE_PATIENT_BILL = "deleteBill",

  ADD_DISCOUNT = "createDiscount",
  GET_DISCOUNT = "getDiscount",
  EDIT_DISCOUNT = "updateDiscount",
  DELETE_DISCOUNT = "deleteDiscount",

  GET_BALANCES = "getBalances",
  GET_PATIENT_BALANCE = "getBalanceStatement"
}
